import { Button, Row, Space, Typography } from 'antd';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './index.css';
import { setIsShowChatFeedbackFooter } from '@/store/modules/chatSlice.js';
import { updateConversationAPI } from '@/services/chat.js';
import { useRequest } from 'ahooks';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const ChatFeedback = props => {
  const { t } = useTranslation(['chat']);
  const { externalRef, onClick } = props;
  const { themeMode } = useSelector(state => state.global);
  const dispatch = useDispatch();
  const { runAsync: updateConversationIsFeedback } = useRequest(updateConversationAPI, {
    manual: true,
  });

  const onClickDisable = () => {
    dispatch(setIsShowChatFeedbackFooter(true));

    updateConversationIsFeedback({
      externalRef,
      isFeedback: 1,
    });
  };

  return (
    <div className={themeMode === 'dark' ? 'chat-footer-dark' : 'chat-footer'}>
      <Row justify="center">
        <Space size="large">
          <Text strong>{t('chat:footerFeedback.question')}</Text>
          <Button shape="round" type="primary" onClick={onClickDisable}>
            {t('chat:footerFeedback.yes')}
          </Button>
          <Button shape="round" onClick={onClick}>
            {t('chat:footerFeedback.no')}
          </Button>
        </Space>
      </Row>
    </div>
  );
};

export default ChatFeedback;
